import { Component, Input } from '@angular/core';

import { IButtonIcon } from '../interfaces/button-icon.interface';
import { SizeEnum, Sizes } from '../../../shared/enums/size.enum';

@Component({
    selector: 'odd-button',
    templateUrl: './button.component.html',
})

export class ButtonComponent {
    @Input() public readonly label: string;
    @Input() public readonly isLoading: boolean;
    @Input() public readonly isDisabled: boolean;
    @Input() public readonly isOutlined: boolean;
    @Input('class') public readonly clazz: string;
    @Input() public readonly leftIcon: IButtonIcon;
    @Input() public readonly rightIcon: IButtonIcon;
    @Input() public readonly type: string = 'button';
    @Input() public readonly size: Sizes = SizeEnum.default;
}
